import moment from "moment";

export const consultationTransactionsTableColumns = [
  {
    field: "transactionId",
    headerName: "ID Transaction",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.identifiantTransaction ?? "-",
  },
  {
    field: "role",
    headerName: "Rôle",
    flex: 0.9,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.role ?? "-",
  },
  {
    field: "operateur",
    headerName: "Opérateur",
    flex: 1.7,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.operateur ?? "-",
  },
  {
    field: "user",
    headerName: "Utilisateur",
    flex: 1.2,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.utilisateur.username ?? "-",
  },
  {
    field: "referenece",
    headerName: "Référence",
    flex: 1.7,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.referenceDeclenchement ?? "-",
  },
  {
    field: "date",
    headerName: "Date",
    flex: 1.5,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) =>
      Boolean(row.dateCreation)
        ? moment(row.dateCreation).format("DD MMMM YYYY HH:mm")
        : "-",
  },
  {
    field: "statut",
    headerName: "Statut",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.statutTransaction ?? "-",
  },
  {
    field: "numeroSouscription",
    headerName: "N° Souscription",
    flex: 1.2,
    sortable: false,
    editable: false,
    titleGetter: (row) => row.numeroSouscription,
    valueGetter: ({ row }) =>
      row.numeroSouscription ? (
        <a href={`/souscriptions/detail/${row.idSouscription}`}>
          {row.numeroSouscription}
        </a>
      ) : (
        "-"
      ),
  },
  {
    field: "dateAnnulation",
    headerName: "Date d'annulation",
    flex: 1.2,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) =>
      Boolean(row.dateAnnulation)
        ? moment(row.dateAnnulation).format("DD MMMM YYYY")
        : "-",
  },
  {
    field: "motifAnnulation",
    headerName: "Motif d'annulation",
    flex: 2,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.motifAnnulation?.description ?? "-",
  },
];
